// N.V Tech staging stage. A copy of environment.prod.ts's key set --
// the key SETS are pinned equal by test/nvtech-config.test.mts -- with the ruled
// per-stage values of b8c6276a and d9c3645.
//
// Observability is OFF (A5, confirmed in the coordinator amendments of 2026-10-02):
// an empty sentryDsn disables @sentry/angular's init, the sample rates are 0, and
// the Google tag is absent from src/index.nvtech.html. Test traffic must not land
// in old prod's Sentry or Analytics projects.
//
// tokenHashSalt is NOT a literal here. It is generated at build time into the
// git-ignored nvtech-build-values.ts by tools/write-nvtech-build-values.mjs, so the
// booking-token salt never becomes a committed value (estate ledger 6fefcbd).
import { NVTECH_TOKEN_HASH_SALT } from './nvtech-build-values';

export const environment = {
    production: true,
    dev: false,
    galleryUrl: 'test.ourpixo.com',
    bookingsBaseUrl: 'https://api-staging.pixomaticc.com/6',
    eventsBaseUrl: 'https://api-staging.pixomaticc.com/2',
    photosBaseUrl: 'https://api-staging.pixomaticc.com/3',
    usersBaseUrl: 'https://api-staging.pixomaticc.com/1',
    notificationsBaseUrl: 'https://api-staging.pixomaticc.com/5',
    paymentsBaseUrl: 'https://api-staging.pixomaticc.com/4',
    tokenHashSalt: NVTECH_TOKEN_HASH_SALT,
    mediaCdnDomain: 'm-staging.pixomaticc.com',
    eventPhotoPrefix: 'EVNT',
    profilePhotoPrefix: 'PRFL',
    apiKey: '',
    sentryDsn: '',
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    allowedHosts: ['*.app-staging.pixomaticc.com'],
    requiredDbName: 'ourpixo_staging',
    requiredDbHost: 'staging-db.dc5tnoi.mongodb.net',
};
